import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import ProcessSection from "@/components/ProcessSection";
import ProjectsSection from "@/components/ProjectsSection";
import AboutSection from "@/components/AboutSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import InstagramSection from "@/components/InstagramSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import SEOHead from "@/components/SEOHead";

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "حسن عبدالله للمقاولات والديكورات",
  "alternateName": "Hassan Abdullah Contracting & Decorations",
  "description": "أفضل شركة ديكورات وتشطيبات ومقاولات عامة بالرياض — دهانات، جبس بورد، ورق جدران، بديل رخام، باركيه، ترميم بأعلى جودة",
  "url": "https://decoriyaa.com",
  "telephone": "+966556641963",
  "image": "https://decoriyaa.com/og-image.jpg",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "الرياض",
    "addressRegion": "الرياض",
    "addressCountry": "SA"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 24.7136,
    "longitude": 46.6753
  },
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": ["Saturday", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday"],
    "opens": "08:00",
    "closes": "18:00"
  },
  "areaServed": {
    "@type": "City",
    "name": "الرياض"
  },
  "priceRange": "$$$$",
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "خدمات الديكور والمقاولات",
    "itemListElement": [
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "ديكورات وتصميم داخلي" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "دهانات داخلية وخارجية" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "جبس بورد" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "ورق جدران" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "بديل الرخام" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "ترميم ومقاولات عامة" } }
    ]
  }
};

const Index = () => {
  return (
    <div className="min-h-screen">
      <SEOHead
        title="ديكورات وتشطيبات بالرياض | حسن عبدالله للمقاولات"
        description="حسن عبدالله للمقاولات والديكورات — أفضل خدمات الديكورات والدهانات والجبس بورد وورق الجدران والترميم والمقاولات العامة بالرياض بجودة عالية وأسعار مناسبة."
        canonical="/"
        schema={localBusinessSchema}
      />
      <Header />
      <HeroSection />
      <ServicesSection />
      <ProcessSection />
      <ProjectsSection />
      <AboutSection />
      <TestimonialsSection />
      <InstagramSection />
      <ContactSection />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Index;
